import React from "react";

// Tiny label/value display row used in profile + member detail cards.
export function InfoItem({ label, value }) {
  return (
    <div className="info-item">
      <div className="info-label">{label}</div>
      <div className="info-value">{value || "—"}</div>
    </div>
  );
}

export default InfoItem;
